// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"pageLoader_spinnerWrapper__iwd18","spinner":"pageLoader_spinner__-ZXlk","spinner-y0fdc1":"pageLoader_spinner-y0fdc1__xwVUW"};